module.exports = __webpack_public_path__ + "img/img_hula_banner.69c27414.png";